import {StyledDivider} from './SectionDividerLineComponentStyle'
import PropTypes from 'prop-types'

const SectionDividerLineComponent = ({showNotification}) => {
  SectionDividerLineComponent.propTypes = {
    showNotification: PropTypes.bool
  }
  return <StyledDivider data-testid='styled-divider' showNotification={showNotification} />
}
export default SectionDividerLineComponent
